import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Certificationdetail.module.scss'
import iconBack from '../../static/home/icon_back2.png'
import BottomPage from '../Bottom/index'
import { useNavigate } from 'react-router-dom';
// 辅助函数：解析查询参数
const useQuery = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

const DetailPage = () => {
  const navigate = useNavigate();
  const queryParams = useQuery();
   const [attestationModel, setattestationModel] = useState();  // 是否加载中
  const [venueName, setvenueName] = useState(); 
 const [venueLevel, setvenueLevel] = useState(); 
   const [venueAddress, setvenueAddress] = useState(); 
  const [attestationName, setattestationName] = useState();  // 表格数据
  const [attestationNumber, setattestationNumber] = useState();  // 是否显示详情
  const [attestationType, setattestationType] = useState();  // 当前激活的导航项
  const [certificationBasis, setcertificationBasis] = useState('');  // 公司名称
  const [closingDate, setclosingDate] = useState('');  // 公司 ID
  const [createAt, setcreateAt] = useState('');  // 是否为 PDF 文件
  const [createBy, setcreateBy] = useState('');  // 图片或 PDF 地址
  const [displayStatus, setdisplayStatus] = useState();
  const [id, setid] = useState('');
  const [imageAddress, setimageAddress] = useState(); // 默认每页条数
  const [issueDate, setissueDate] = useState('');
  const [memberName, setmemberName] = useState('');
  const [productionAddress, setproductionAddress] = useState('');
  const [status, setstatus] = useState('');
  const [isOnShow, setIsOnShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  useEffect(() => {
    setattestationModel(queryParams.get('attestationModel'));
    setattestationName(queryParams.get('attestationName'));
    setattestationNumber(queryParams.get('attestationNumber'));
    setattestationType(queryParams.get('attestationType'));
    setcertificationBasis(queryParams.get('certificationBasis'));
    setclosingDate(queryParams.get('closingDate'));
    setcreateAt(queryParams.get('createAt'));
    setcreateBy(queryParams.get('createBy'));
    setdisplayStatus(queryParams.get('displayStatus'));
    setid(queryParams.get('id'));
    setimageAddress(queryParams.get('imageAddress'));
    setissueDate(queryParams.get('issueDate'));
    setmemberName(queryParams.get('memberName'));
    setproductionAddress(queryParams.get('productionAddress'));
    setstatus(queryParams.get('status'));

    setvenueName(queryParams.get('venueName'));
    setvenueLevel(queryParams.get('venueLevel'));
    setvenueAddress(queryParams.get('venueAddress'));
  }, []);  // 依赖 memberItem，当它变化时重新执行
  const openRenders = () => {
    var bloos = imageAddress.endsWith('.pdf')
    setIsPDF(bloos)

    setIsOnShow(true)

  }
  const closeImgs = () => {
    setIsOnShow(false)
  }
  const toback = () => {
    navigate(-1)
  }
  return (
    <div className={styles.detailAll}>
      <div className={styles.detail}>
        <div className={styles.detailContents}>
          <div className={styles.neirongBox}>
            <div className={styles.leftText}>证书编号：</div>
            <div className={styles.rightConts}>{attestationNumber}</div>
          </div>
          {attestationType === '1' && (
            <div className={styles.neirongBox}>
              <div className={styles.leftText}>产品名称：</div>
              <div className={styles.rightConts}>{attestationName}</div>
            </div>
          )}
          {attestationType === '1' && (
            <div className={styles.neirongBox}>
              <div className={styles.leftText}>产品型号：</div>
              <div className={styles.rightConts}>{attestationModel}</div>
            </div>
          )}

           {attestationType == '4' && (
              <div className={styles.neirongBox}>
            <div className={styles.leftText}>场地名称：</div>
            <div className={styles.rightConts}>{venueName}</div>
          </div>
          )}
           {attestationType == '4' && (
              <div className={styles.neirongBox}>
            <div className={styles.leftText}>场地等级：</div>
            <div className={styles.rightConts}>{venueLevel}</div>
          </div>
          )}
             {attestationType == '4' && (
              <div className={styles.neirongBox}>
            <div className={styles.leftText}>场地地址：</div>
            <div className={styles.rightConts}>{venueAddress}</div>
          </div>
          )}
           {attestationType !== '4' && (
              <div className={styles.neirongBox}>
            <div className={styles.leftText}>认证依据：</div>
            <div className={styles.rightConts}>{certificationBasis}</div>
          </div>
          )}
       

          {attestationType === '1' && (
            <div className={styles.neirongBox}>
              <div className={styles.leftText}>生产地址：</div>
              <div className={styles.rightConts}>{productionAddress}</div>
            </div>
          )}
          <div className={styles.neirongBox}>
            <div className={styles.leftText}>发证日期：</div>
            <div className={styles.rightConts}>{issueDate}</div>
          </div>
          <div className={styles.neirongBox}>
            <div className={styles.leftText}>状态：</div>
            <div className={styles.rightConts}>{status}</div>
          </div>
          <div className={styles.neirongBox}>
            <div className={styles.leftText}>证书详情：</div>
            <div className={styles.Rightbtns} onClick={openRenders}>查看</div>
          </div>
        </div>
      </div>
      {
        isOnShow && (
          <div onClick={closeImgs} className={styles.etCety}>
            <div className={styles.bottomBtns}>
              <div >
                {isPDF ? (
                  <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
                    <iframe
                      src={`${imageAddress}#toolbar=0&navpanes=0&scrollbar=0`}
                      title="PDF Preview"
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        // backgroundColor: '#fff',
                        overflow: 'auto', // 确保 PDF 内容可以滚动
                      }}
                    ></iframe>
                  </div>
                ) : (
                  <div className={styles.containerStyle}>
                    <img src={imageAddress} alt="" className={styles.imageStyle} />
                  </div>
                )}
              </div>

            </div>
          </div>
        )
      }
      <BottomPage></BottomPage>
    </div>
  );
};

export default DetailPage;



